export interface SessionPayload {
  sub: string;
  role: 'employee' | 'manager';
  exp: number;
}

export function decodeJwtPayload(token: string): SessionPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    const payload = JSON.parse(json);
    if (!payload.exp || payload.exp * 1000 < Date.now()) return null;
    return payload as SessionPayload;
  } catch {
    return null;
  }
}
